import { AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTableFilterType, AimsCommonTablePermissions, TableRowUpdate } from '@aims/common-components';
import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { FacEquipmentOwners } from 'src/models';

@Component({
  selector: 'aims-config-owners',
  templateUrl: './config-owners.component.html',
  styleUrls: ['./config-owners.component.css'],
  providers: [MainGridService]
})
export class ConfigOwnersComponent implements OnInit {

  constructor(
    private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>
  ) {
    this.initialTableObject = new FacEquipmentOwners();
    this.initialTableObject.active = true;
  }

  @Input() permissionNeeded: number;
  resources: Observable<any> = this.mainGridService.getAll('Facilities/GetOwners', 'Facilities/SaveOwners');
  initialTableObject:FacEquipmentOwners;

  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN },
    { key: 'equipmentOwner', label: 'Owner', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.required] },
    { key: 'equipmentOwnerIdOld', label: 'Owner Code', type: AimsCommonTableHeaderType.STRING, validatorOrOpts: [Validators.required] }
  ]
  tablePermissions: Observable<AimsCommonTablePermissions>;

  handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe())
  }

  handleRowAdd(update: TableRowUpdate): void {
    this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe())
  }

  ngOnInit(): void {
    this.tablePermissions = this.permissions.getDataGridPerms$(this.permissionNeeded, { export: false, delete: false });
  }
}
